// Copyright ©️ 2026 eVolve MEP, LLC

/** Returns the first non-empty value from those provided */
export const firstNonEmpty = <T extends string | number | null | undefined>(...arr: T[]) => arr.find((x) => !!x);
